module.exports = __webpack_public_path__ + "static/genasi-fire-1-1dfd6149c3e749c58d954161e328d2d5.jpg";